import { IInstitution, IError, IQueryHookOptions } from '@comptia-sso/core';
import { useQuery } from 'react-query';

// Services.
import { getInstitution } from 'services';

type UseInstitution = [IInstitution, IQueryHookOptions];

export const useInstitution = (id = ''): UseInstitution => {
  const {
    data = {} as IInstitution,
    error,
    isError,
    isLoading,
  } = useQuery<IInstitution, IError>(
    ['institutions', id],
    () => getInstitution(id),
    {
      enabled: !!id,
    },
  );

  return [data, { error, isError, isLoading }];
};
